module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-Sg-film-black.df1fe6b.png";